import { useLingui } from "@lingui/react";
import { LinkProps, Link as RouterLink } from "react-router-dom";

export function Link({ to, ...props }: LinkProps) {
  const { i18n } = useLingui();
  const locale = i18n.locale ?? "it";

  // Handle both string and object forms of 'to'
  let localizedTo: LinkProps["to"];

  if (typeof to === "string") {
    localizedTo = `/${locale}${to}`;
  } else if (typeof to === "object" && to !== null && "pathname" in to) {
    localizedTo = {
      ...to,
      pathname: `/${locale}${to.pathname || ""}`,
    };
  } else {
    localizedTo = to;
  }

  return <RouterLink to={localizedTo} {...props} />;
}
